import * as React from 'react';

import type {PreviewType} from './consts';

type Props = {
    embedScript: string;
    previewType: PreviewType;
    instanceId: string | number;
    isDevelopment?: boolean;
};

export function Footer({embedScript, previewType, instanceId, isDevelopment}: Props) {
    const containerRef = React.useRef<HTMLDivElement | null | undefined>(null);

    React.useEffect(() => {
        if (embedScript && containerRef.current) {
            const container = containerRef.current;
            container.innerHTML = embedScript;

            const bootDiv = container.querySelector(`#nutshell-boot-${instanceId}`);
            if (bootDiv && previewType) {
                bootDiv.setAttribute('previewType', previewType);
            }

            const scripts = container.querySelectorAll('script');
            scripts.forEach((scriptElement) => {
                const script = scriptElement as HTMLScriptElement;
                const newScript = document.createElement('script');
                if (script.src) {
                    const isModule = script.type === 'module';

                    // In dev, the ESM build doesn't exist — use the IIFE version
                    // which handles ESM loading of peanut/chat internally.
                    if (isDevelopment && isModule) {
                        newScript.src = script.src.replace('nutsheller-esm.js', 'nutsheller.js');
                    } else {
                        newScript.src = isModule ? `${script.src}?id=${Date.now()}` : script.src;
                        if (isModule) {
                            newScript.type = 'module';
                        }
                    }
                    newScript.async = true;
                } else {
                    newScript.textContent = script.textContent;
                }
                document.head.appendChild(newScript);
            });
        }

        return () => {
            // Full reset so the boot script queues commands fresh on re-mount.
            // @ts-expect-error
            delete window.Nutsheller;
        };
    }, [embedScript, previewType, instanceId, isDevelopment]);

    return (
        <footer>
            {/* @ts-expect-error */}
            <div ref={containerRef} />
        </footer>
    );
}
